import { OutputSurveyTemplate } from '~/interfaces/survey_template.interface';
import { surveyElementFrom } from './survey_element.transformer';

type Name = {
  name: String;
  languageId: Number;
};

export type TransformedSurveyTemplate = OutputSurveyTemplate & {
  translations: Record<string, string>;
  surveyTypeTranslations: Record<string, string>;
};

function generateTranslations(names?: Name[]) {
  if (!names?.length) return {};
  return names.reduce((acc, name) => {
    acc[`${name.languageId}`] = name.name;
    return acc;
  }, {});
}

const surveyTemplateFrom = (surveyTemplate: OutputSurveyTemplate) => {
  const transformedSurveyElements =
    surveyTemplate.surveyElements && surveyTemplate.surveyElements.map((question) => surveyElementFrom(question));
  const translations = generateTranslations(surveyTemplate.names);
  const surveyTypeTranslations = generateTranslations(surveyTemplate?.surveyType?.names as Name[]);

  return {
    ...surveyTemplate,
    surveyElements: transformedSurveyElements,
    translations,
    surveyTypeTranslations,
  };
};

const surveyTemplatesFrom = (surveyTemplates: OutputSurveyTemplate[]) => {
  return surveyTemplates.map((surveyTemplate) => surveyTemplateFrom(surveyTemplate));
};

export { surveyTemplateFrom, surveyTemplatesFrom };
